module.exports = __webpack_public_path__ + "img/dress-room.28eb2039.png";